import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState = {
    users: [],
};

export const paymentEligibleUsersStateSlice = createSlice({
    name: "paymentEligibleUsersState",
    initialState,
    reducers: {
        setGlobalPaymentEligibleUsers: (
            state,
            data: PayloadAction<string[]>,
        ) => {
            state.users = data.payload;
            return state;
        },
        resetPaymentEligibleUsers: () => {
            return initialState;
        },
    },
});
export const { setGlobalPaymentEligibleUsers, resetPaymentEligibleUsers } =
    paymentEligibleUsersStateSlice.actions;
